import { PMDonutChartCard } from "@pimo/pimo-components/src/lib/pm-components";

import { APP_ROUTES } from "../../../constants";
import { getDropdownCount } from "../../../utils/dropdown-options";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addCompletionOfProjectsCard(ctx: DashboardCardContext) {
  const { view, app, language, getCardCopy } = ctx;

  const completionOfProjectsComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "completionOfProjectsComponent",
      title: "",
      description: "",
      labels: ["donutChart", "chart", "maturity"],
    },
  });

  completionOfProjectsComponent.mapLayoutProps(() => {
    return {
      componentId: "completionOfProjectsComponent",
      labels: ["donutChart", "chart", "maturity"],
      title: getCardCopy(language, "completionOfProjects").title,
      description: getCardCopy(language, "completionOfProjects").description,
    };
  });

  completionOfProjectsComponent.mapState((appState) => {
    const projectDegreeOfCompletionCounts =
      appState.dashboard?._calculated?.projectDegreeOfCompletionCounts ?? {};
    const data =
      appState.settings?.configuration?.degreeOfCompletionDefinition?.map(
        (entry) => {
          return {
            label: entry.name ?? "",
            value: getDropdownCount(projectDegreeOfCompletionCounts, entry),
            color: entry.color ?? "",
          };
        }
      ) ?? [];

    const handleCompletionFilter = (completion?: string) => {
      app.patchAppState({
        filterData: {
          searchQueryFilter: [],
          statusFilter: [],
          completionFilter: completion ? [completion] : [],
          categoryFilter: [],
          updateStatusFilter: [],
        },
      });
      app.navigate(APP_ROUTES.overview);
    };

    return {
      title: getCardCopy(language, "completionOfProjects").title,
      icon: "DonutLarge",
      data,
      onCardClick: () => handleCompletionFilter(),
      onSegmentClick: (segmentIndex: number) =>
        handleCompletionFilter(data[segmentIndex]?.label),
    };
  });

  completionOfProjectsComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
